module.exports = __webpack_public_path__ + "static/sila-58a0f676288d1f53c7c3542b4828c59e.png";